export default __webpack_public_path__ + "static/Smithy-1699d55171e83f5b0a5679e878461935.png";